import { Box } from '@mui/material';
import { Observer } from 'mobx-react';
import { loadAge } from 'modules/Dashboard/actions/age.action';
import { DASHBOARD_STATES } from 'modules/Dashboard/constants/dashboard.constants';
import { DashboardStore } from 'modules/Dashboard/stores/dashboard.store';
import { chartRangePickerStore } from 'modules/Dashboard/stores/interval.store';
import { dashboardRacesStore } from 'modules/Dashboard/stores/races.store';
import { mergeRaceForm } from 'modules/Dashboard/utils/merge-race-form.utils';
import { useEffect, useState } from 'react';

import { Form } from 'components/Form';
import { Spinner } from 'components/Spinner';

import { progressStore } from 'stores';

import Age from './Age';

export default function MobXRegistrationsWrapper() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(DashboardStore.age.value?.data ?? []);

  useEffect(() => {
    if (DashboardStore.age.value?.range === 1 || data.length === 0) {
      setIsLoading(true);
      const load = async () => {
        try {
          await loadAge(2, true, dashboardRacesStore.races.length > 0);
          setData(DashboardStore.age.value?.data ?? []);
          mergeRaceForm();
        } catch (error) {
        } finally {
          setIsLoading(false);
        }
      };
      load();
    }
    return () => {
      chartRangePickerStore.reset();
    };
  }, []);

  if (isLoading) {
    return (
      <Box>
        <Spinner type='cubesSpinner' />
      </Box>
    );
  }

  return (
    <Box sx={{ overflow: 'scroll', height: '100%', backgroundColor: '#FAFAFA' }}>
      <Form id={DASHBOARD_STATES.RACE_SEARCH_FORM}>
        <Observer
          render={() => {
            if (progressStore.isLoading(DASHBOARD_STATES.AGE_LOADING) || progressStore.isLoading(DASHBOARD_STATES.LOADING)) {
              return (
                <>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'fixed',
                      height: '100%',
                      width: '100%',
                      backgroundColor: 'white',
                      opacity: '0.6',
                      zIndex: 5,
                    }}
                  >
                    <Spinner type='cubesSpinner' />
                  </Box>
                  <Age data={{ data: [], range: 2 }} />;
                </>
              );
            }
            return <Age data={DashboardStore.age.value} />;
          }}
        />
      </Form>
    </Box>
  );
}
